import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs } from "vue";
import { Field } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectNumber',
  props: {
    name: {},
    placeholder: {},
    initialValue: {}
  },
  setup(__props: any) {

const props = __props;


const { initialValue, placeholder, name } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Field), {
    type: "number",
    value: _unref(initialValue),
    step: "0.1",
    min: 0,
    class: "text-raleway-13 input search-sm-input pr-2",
    placeholder: _ctx.$tc(_unref(initialValue) || _unref(placeholder)),
    name: _unref(name)
  }, null, 8, ["value", "placeholder", "name"]))
}
}

})